// extracted by mini-css-extract-plugin
module.exports = {"products":"BuyProducts_products__1Z80U"};